<div class="full-screen">
    <div class="content">
        <h2>Logged out Successfully</h2>
        <p>You have logged out successfully.</p>
    </div>
</div>
